module.exports = __webpack_public_path__ + "static/media/photoActive.0f717f30.svg";